import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Grid,
    Button,
    Card,
    Image,
    GridColumn,
    Dropdown,
    Label,
    Modal,
    Form,
    Input,
    Dimmer,
    Loader,
    TextArea
} from "semantic-ui-react";
import ButtonHandler from "../../ButtonHandler.jsx";
import processIcon from "../../../Images/process.png";
import config from "../../../config.js";
import excel from "../../../Images/excel_icon.png";
import CheckboxTable from "../CheckboxView.jsx";
import {
    fetchAutomationStatusData, runAutomationScript, fetchUseraction,
    getDisbursementFormulas, updateDisbursementFormulas, fetchTemplates,
    getWorkingFiles, rawFileProcess, getsplittedFiles, getSplitFilesFormulas,
    updateSplitFileFormulas,
    processApprovedFiles,
    splitSitewiseProcess,
    sendWorkingFiles,
    processCreditNote,
    sendCreditNoteFiles,
    getHotspotSplitStatus,
    getPlanData,
    checkHotspotInputsData,
    extractHotspotTemplateCol,
    saveHotspotTemplateCol,
    getHotspotTemplateConditions,
    getApprovedEmails,
    getCreditNoteProcessStatus,
    downloadallDSEfiles,
    downloadallCreditNotefiles,
    sendApprovalEmailToPandG,
    compareTemplateColumns,
    getPreviousMonthTemplate
} from '../../../actions/users_action';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import TextField from '@mui/material/TextField';

var apiTimeout = null
class HotspotAutomation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            automationStatus: 'Pending',
            initial: true,
            outputUrl: '',
            downloadEnable: false,
            templateId: "",
            distributors: [],
            selectedDistributor: '',
            formulaModalOpen: false,
            formulas: [],
            selectedTemplate: '',
            templates: [],
            automationSplitFiles: [],
            modalOpen: false,
            fileUploaded: false,
            fileName: '',
            currentFile: {},
            workingFiles: [],
            auditingSplit: [],
            nonAuditingSplit: [],
            formulasType: '',
            loaderStatus: false,
            selectedDist: {},
            disType: 'Hotspot',
            selectedYear: '',
            missingFiles: [],
            proceed: false,
            splitProcess: true,
            validationModalOpen: false,
            templateCol: [],
            templateColModal: false,
            hotspotNonAuditUrl:'',
            hotspotAuditingUrl:'',
            approvedHotspotAuditingUrl:'',
            approvedHotspotNonAuditingUrl:'',
            approvalModalOpen:false,
            approvedEmailData:[],
            alertModalOpen:false,
            releaseAlertMoalOpen:false,
            startDate: null,
            endDate: null,
            templateComparisonModalOpen: false,  // apply conditions template comparision
            comparisonResult: null  // apply conditions template comparision
        };
    }

    async componentDidMount() {
        let templateMonths = []
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                res.templates.map((d) => {
                    if (this.state.selectedYear == d.year) {
                        templateMonths.push({
                            'key': d._id,
                            'value': d.name.slice(0, -4),
                            'text': d.name.slice(0, -4)
                        })
                    }

                })

                // Store templates but don't auto-select
                this.setState({ templates: res.templates, templateMonths: templateMonths })
            },
            onFailure: () => {
            }
        })



    }

    componentWillUnmount() {
        // Clean up all polling timeouts when component unmounts
        if (apiTimeout) {
            clearTimeout(apiTimeout);
            apiTimeout = null;
        }
    }

    // start = () => {

    //     if (this.state.selectedDistributor != '') {
    //         if (this.state.startDate != ''){
    //             if (this.state.endDate != ''){
    //                 this.setState({
    //                     automationStatus: 'Processing',
    //                     initial: false
    //                 })
        
    //                 apiTimeout = setTimeout(this.loadData, 3000)
        
    //                 let data = {
    //                     templateId: this.state.templateId,
    //                     distributorList: this.state.selectedDistributor
    //                 }
    //                 this.props.runAutomationScript(data, {
    //                     onSuccess: () => {
        
    //                     },
    //                     onFailure: () => {
        
    //                     }
    //                 })
    //             } else {
    //                 alert('Please select the Sales end date.')
    //             }
    //         }  else {
    //             alert('Please select the Sales start date.')
    //         }
    //     }
    //     else {
    //         alert('Please Select Distributor')
    //     }

    // }

    validateStart = () => {
        if (!this.state.selectedDistributor) return 'Please select Distributor.';
        if (!this.state.startDate) return 'Please select Mid-Month sales start date.';
        if (!this.state.endDate) return 'Please select Mid-Month sales end date.';
        return null;
    }

    start = () => {

        const error = this.validateStart()
        if (error) {
            alert(error)
            return;
        }

        // ✅ All validations passed
        this.setState({
            automationStatus: 'Processing',
            initial: false
        });

        apiTimeout = setTimeout(this.loadData, 3000);

        // Normalize dates to remove timezone issues
        // Set time to noon (12:00) to avoid timezone conversion issues
        const normalizeDate = (date) => {
            if (!date) return null;
            const normalized = new Date(date);
            normalized.setHours(12, 0, 0, 0);
            return normalized.toISOString();
        };

        const data = {
            templateId: this.state.templateId,
            distributorList: this.state.selectedDistributor,
            salesStartDate: normalizeDate(this.state.startDate),
            salesEndDate: normalizeDate(this.state.endDate)
        };

        this.props.runAutomationScript(data, {
            onSuccess: () => {},
            onFailure: () => {}
        });
    };


    loadData = () => {

        if (this.state.automationStatus !== 'Processing'){
            clearTimeout(apiTimeout)
            return
        }

        this.props.fetchAutomationStatusData(this.state.templateId, {
            onSuccess: (res) => {
                if (res.automation_status.length > 0) {
                    res.automation_status.map((d) => {
                        if (d.file && d.file == 'FinalOutput' && d.disbursementType == this.state.disType) {
                            // Check for completion
                            if (d.fileUploadStatus == 'Completed') {
                                this.setState({ 
                                    automationStatus: d.fileUploadStatus, 
                                    downloadEnable: true,
                                    outputUrl: d.finalOutputUrl  // ✅ Update the URL when completed
                                })
                                clearTimeout(apiTimeout)
                            }
                            // Check for failure
                            else if (d.fileUploadStatus == 'Failed') {
                                this.setState({ automationStatus: 'Failed', downloadEnable: false })
                                clearTimeout(apiTimeout)
                                // Show error message to user
                                const errorMsg = d.errorMessage || 'Automation failed. Please check the logs.'
                                alert(errorMsg)
                            }
                            // If status is Processing, just continue polling
                            else if (d.fileUploadStatus == 'Processing') {
                                // Keep current state, continue polling
                            }
                        }
                    })
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadData, 3000)
    }

    downloadfile = (url) => {
        console.log('download url - ', url)
        window.open(url);
    }

    dropDownDistributorOnChange = (e, data) => {
        let filteredArray;
        if (data.value.includes('All') && data.value.length > 0) {
            filteredArray = data.value.filter((element) => element === 'All')
        }
        else {
            filteredArray = data.value.filter((element) => element !== 'All')
        }
        this.setState({ selectedDistributor: filteredArray })
    }

    dropDownYearOnChange = (e, data) => {
        let templateMonths = []
        this.state.templates.map((d) => {
            if (data.value == d.year) {
                templateMonths.push({
                    'key': d._id,
                    'value': d.name.slice(0, -4),
                    'text': d.name.slice(0, -4)
                })
            }

        })
        this.setState({ selectedYear: data.value, templateMonths: templateMonths })
    }

    removeDuplicates = (arr) => {
        return arr.filter((v, i, a) => a.findIndex(v2 => (v2.text === v.text)) === i);
    }

    dropDownTemplateOnChange = (e, data) => {
        console.log('data : HotspotAutomation.jsx - ', data)
        data.options.map((d) => {
            if (d.value == data.value) {
                this.setState({ templateId: d.key })
                this.props.fetchUseraction(
                    d.key,
                    {
                        onSuccess: (res) => {
                            let dis_list = []
                            if (res.users.length > 0) {
                                res.users.map((d) => {
                                    if (d.siteName && d.role == 'distributor') {
                                        dis_list.push({
                                            'key': d.siteName,
                                            'value': d.siteName,
                                            'text': d.siteName
                                        })
                                    }

                                })
                            }
                            dis_list.push({
                                'key': 'All',
                                'value': 'All',
                                'text': 'All'
                            })

                            this.setState({ distributors: this.removeDuplicates(dis_list) })
                        },
                        onFailure: () => { this.setState({ loading: false }) }
                    });
                this.props.getWorkingFiles(
                    d.key, this.state.disType,
                    {
                        onSuccess: (res) => {
                            
                            this.setState({ automationSplitFiles: res.workingFiles })
                            let hotspotAuditingUrl = ''
                            let hotspotNonAuditUrl = ''
                            let approvedHotspotAuditingUrl = ''
                            let approvedHotspotNonAuditingUrl = ''
                            res.workingFiles.map((d) => {
                                if (d.fileName == 'Auditing Site' && d.fileType == 'Hotspot') {
                                    hotspotAuditingUrl = d.result && d.result.length && d.result[0]
                                }
                                else if(d.fileName == 'Non Auditing' && d.fileType == 'Hotspot'){
                                    hotspotNonAuditUrl = d.result && d.result.length && d.result[0]
                                }
                                else if(d.fileName == 'Auditing' && d.fileType == 'Hotspot Approved'){
                                    approvedHotspotAuditingUrl = d.result && d.result.length && d.result[0]
                                }
                                else if(d.fileName == 'NonAuditing' && d.fileType == 'Hotspot Approved'){
                                    approvedHotspotNonAuditingUrl = d.result && d.result.length && d.result[0]
                                }
                            })
                            
                            this.setState({ hotspotAuditingUrl: hotspotAuditingUrl,hotspotNonAuditUrl:hotspotNonAuditUrl,approvedHotspotAuditingUrl:approvedHotspotAuditingUrl,approvedHotspotNonAuditingUrl:approvedHotspotNonAuditingUrl })
                        },
                        onFailure: () => {
                        }
                    })
                this.props.getsplittedFiles(
                    d.key,
                    {
                        onSuccess: (res) => {
                            this.setState({ auditingSplit: res.auditingFiles, nonAuditingSplit: res.nonAuditingFiles })
                        },
                        onFailure: () => {
                        }
                    })

                this.props.getPlanData(d.key, {
                    onSuccess: (res) => {
                        if (res.files.length > 0) {
                            res.files.map((d) => {
                                if (d.fileName == "hotspotTemplate") {
                                    this.setState({ templateDataUrl: d.result[0] })
                                }
                                else if (d.fileName == "hotspotPlanData") {
                                    // console.log(d, 'dddd')
                                    this.setState({ planDataUrl: d.result[0] })
                                }
                                else if(d.fileName == "hotspotPgTargetData"){
                                    this.setState({ pgTargetDataUrl: d.result[0] })
                                }
                            })

                        }
                        else {
                            this.setState({ templateDataUrl: '', planDataUrl: '' })
                        }
                    },
                    onFailure: () => {

                    }
                })

                this.props.fetchAutomationStatusData(
                    d.key,
                    {
                        onSuccess: (res) => {
                            // console.log(res.automation_status, 'automation status')
                            if (res.automation_status.length > 0) {
                                const matchingItem = res.automation_status.find(d => d.disbursementType === this.state.disType);

                                if (matchingItem && matchingItem.file && matchingItem.fileUploadStatus === 'Completed' && matchingItem.file === 'FinalOutput') {
                                    this.setState({
                                        outputUrl: matchingItem.finalOutputUrl,
                                        automationStatus: matchingItem.fileUploadStatus,
                                        initial: false,
                                        downloadEnable: true
                                    });
                                } else {
                                    this.setState({
                                        outputUrl: '',
                                        automationStatus: 'Pending',
                                        initial: true,
                                        downloadEnable: false
                                    });
                                }
                            } else {
                                this.setState({
                                    outputUrl: '',
                                    automationStatus: 'Pending',
                                    initial: true,
                                    downloadEnable: false
                                });
                            }
                        },
                        onFailure: () => {

                        }
                    })

                this.props.getHotspotTemplateConditions(d.key, {
                    onSuccess: (res) => {
                        // console.log(res, 'ress')
                        this.setState({ templateCol: res.colConditions })
                    },
                    onFailure: () => {

                    }
                })
            }
        })
        this.setState({ selectedTemplate: data.value })
    }

    closeFormulaModal = () => {
        this.setState({ formulaModalOpen: false, templateColModal: false,approvalModalOpen:false,alertModalOpen:false,releaseAlertMoalOpen:false })
    }

    formulasModal = (types) => {
        if (types == 'Main') {
            this.props.getDisbursementFormulas({
                onSuccess: (res) => {
                    let formulas_calc = res.data.formulas.slice(2, -2)
                    this.setState({ formulas: formulas_calc })
                },
                onFailure: () => {

                }
            })
            this.setState({ formulasType: types, formulaModalOpen: true })
        }

        else {
            let data = {
                type: types
            }
            this.props.getSplitFilesFormulas(data, {
                onSuccess: (res) => {
                    let formulas_calc = res.formulas
                    this.setState({ formulas: formulas_calc })
                },
                onFailure: () => {

                }
            })
            this.setState({ formulasType: types, formulaModalOpen: true })

        }


    }

    formulaOnChange = (e, data) => {
        let formulas_data = this.state.formulas;
        formulas_data.map((d) => {
            if (Object.keys(d)[0] == Object.keys(data)[0]) {
                d[Object.keys(d)[0]] = e.target.value + '\n'
            }
        })
        this.setState({ formulas: formulas_data })
    }

    saveFormulas = () => {
        let data = {
            formulas: this.state.formulas
        }
        let split_data = {
            formulas: this.state.formulas,
            type: this.state.formulasType
        }
        if (this.state.formulasType == 'Main') {
            this.props.updateDisbursementFormulas(data, {
                onSuccess: () => {
                    this.setState({ formulaModalOpen: false })
                    alert("Formulas File Updated")
                },
                onFailure: () => {

                }
            })
        }
        else {
            this.props.updateSplitFileFormulas(split_data, {
                onSuccess: () => {
                    this.setState({ formulaModalOpen: false })
                    alert("Formulas File Updated")
                },
                onFailure: () => {

                }
            })
        }

    }

    closeuploadoption = () => {
        this.setState({ modalOpen: false, validationModalOpen: false })
    }

    templateUploadCheck = () => {
        const {selectedYear, selectedTemplate} = this.state;
        if (!selectedYear || !selectedTemplate) {
            if (!selectedYear && !selectedTemplate) {
                alert("Please select the Year and Template Month.")
            } else if (!selectedYear) {
                alert("Please select the Year.")
            } else {
                alert("Please select the Template Month.")
            }
            return;
        }

        this.uploadFile('hotspotTemplate', 'hotspotTemplate');
    }

    templateDownloadCheck = () => {
        console.log('templateDownloadCheck called');
        const {selectedYear, selectedTemplate, templateDataUrl} = this.state;
        console.log('State values:', { selectedYear, selectedTemplate, templateDataUrl });
        
        if (!selectedYear || !selectedTemplate) {
            if (!selectedYear && !selectedTemplate) {
                alert('Please select the Year and Template Month.')
            } else if (!selectedYear) {
                alert('Please select the Year.')
            } else {
                alert('Please select the Template Month.')
            }
            return;
        }
        if (!templateDataUrl) {
            alert('Template file not found for the selected month. Please upload the template first.')
            return 
        }
        console.log('Downloading from:',templateDataUrl);
        this.downloadfile(templateDataUrl)
    }

    fileupload = (file) => {
        this.setState({ currentFile: file.target.files[0], fileUploaded: true })
    };

    // uploadRawFile = () => {
    //     this.setState({ loaderStatus: true })
    //     this.props.rawFileProcess(this.state.currentFile, this.state.fileName, this.state.templateId, {
    //         onSuccess: () => {
    //             // Refresh plan data after successful upload to get the new URL
    //             this.props.getPlanData(this.state.templateId, {
    //                 onSuccess: (res) => {
    //                     if (res.files.length > 0) {
    //                         res.files.map((d) => {
    //                             if (d.fileName == "hotspotTemplate") {
    //                                 this.setState({ templateDataUrl: d.result[0] })
    //                             }
    //                             else if (d.fileName == "hotspotPlanData") {
    //                                 this.setState({ planDataUrl: d.result[0] })
    //                             }
    //                         })
    //                     }
                        
    //                     // Clear template column conditions when new template is uploaded
    //                     if (this.state.fileName === 'hotspotTemplate') {
    //                         this.setState({ templateCol: [] })
    //                         console.log('Old template cleared - Hotspot.')
    //                     }
                        
    //                     this.setState({ modalOpen: false, loaderStatus: false })
    //                     alert("File Uploaded Successfully")
    //                 },
    //                 onFailure: () => {
    //                     // Clear template column conditions when new template is uploaded
    //                     if (this.state.fileName === 'hotspotTemplate') {
    //                         this.setState({ templateCol: [] })
    //                     }
                        
    //                     this.setState({ modalOpen: false, loaderStatus: false })
    //                     alert("File Uploaded Successfully")
    //                 }
    //             })
    //         },
    //         onFailure: () => {
    //             this.setState({ loaderStatus: false })
    //             alert("File Upload Failed")
    //         }
    //     })
    // }

    renderTemplateComparisonModal = () => {
        const { comparisonResult } = this.state;
        
        if (!comparisonResult) return null;
        
        const preserved = comparisonResult.preservableCount;
        const total = comparisonResult.existingConditionsCount;
        const lost = total - preserved;
        
        return (
            <Modal
                open={this.state.templateComparisonModalOpen}
                onClose={() => this.setState({ templateComparisonModalOpen: false })}
                size='small'
            >
                <Modal.Header>
                    <Icon name='info circle' color='blue' />
                    Template Column Comparison
                </Modal.Header>
                <Modal.Content>
                    <div style={{ marginBottom: '15px' }}>
                        <h4>Template uploaded successfully!</h4>
                        <p>Here's what happened to your column conditions:</p>
                    </div>
                    
                    <div style={{ padding: '15px', backgroundColor: '#f0f9ff', borderRadius: '5px', marginBottom: '10px' }}>
                        <Icon name='check circle' color='green' />
                        <strong>{preserved} conditions preserved</strong>
                        <p style={{ marginLeft: '25px', color: '#666' }}>
                            These columns exist in both old and new templates
                        </p>
                    </div>
                    
                    {lost > 0 && (
                        <div style={{ padding: '15px', backgroundColor: '#fff3cd', borderRadius: '5px' }}>
                            <Icon name='warning sign' color='orange' />
                            <strong>{lost} conditions removed</strong>
                            <p style={{ marginLeft: '25px', color: '#666' }}>
                                These columns don't exist in the new template
                            </p>
                        </div>
                    )}
                    
                    <div style={{ marginTop: '15px', fontSize: '12px', color: '#888' }}>
                        <Icon name='lightbulb outline' />
                        Tip: Column positions were automatically updated to match the new template layout.
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button 
                        primary 
                        onClick={() => this.setState({ templateComparisonModalOpen: false })}
                    >
                        Got it
                    </Button>
                </Modal.Actions>
            </Modal>
        );
    }

    // Add to render method
    render() {
        return (
            <div>
                {/* ... existing content ... */}
                {this.renderTemplateComparisonModal()}
            </div>
        );
    }

    uploadRawFile = () => {
        this.setState({ loaderStatus: true })
        
        this.props.rawFileProcess(this.state.currentFile, this.state.fileName, this.state.templateId, {
            onSuccess: () => {
                // Refresh plan data after successful upload
                this.props.getPlanData(this.state.templateId, {
                    onSuccess: (res) => {
                        if (res.files.length > 0) {
                            res.files.map((d) => {
                                if (d.fileName == "hotspotTemplate") {
                                    this.setState({ templateDataUrl: d.result[0] })
                                    
                                    // ✅ NEW: Smart template comparison
                                    if (this.state.fileName === 'hotspotTemplate') {
                                        this.handleTemplateComparison(d.result[0]);
                                    }
                                }
                                else if (d.fileName == "hotspotPlanData") {
                                    this.setState({ planDataUrl: d.result[0] })
                                }
                                else if(d.fileName == "hotspotPgTargetData"){
                                    this.setState({ pgTargetDataUrl: d.result[0] })
                                }
                            })
                        }
                        
                        this.setState({ modalOpen: false, loaderStatus: false })
                        alert("File Uploaded Successfully")
                    },
                    onFailure: () => {
                        if (this.state.fileName === 'hotspotTemplate') {
                            this.setState({ templateCol: [] })
                        }
                        
                        this.setState({ modalOpen: false, loaderStatus: false })
                        alert("File Uploaded Successfully")
                    }
                })
            },
            onFailure: () => {
                this.setState({ loaderStatus: false })
                alert("File Upload Failed")
            }
        })
    }

    // ✅ NEW: Handle template comparison
    handleTemplateComparison = (newTemplateS3Path) => {
        console.log('[DEBUG] handleTemplateComparison called');
        console.log('[DEBUG] templateId:', this.state.templateId);
        console.log('[DEBUG] newTemplateS3Path:', newTemplateS3Path);
        
        // First, try to get previous month's template ID
        this.props.getPreviousMonthTemplate(this.state.templateId, {
            onSuccess: (prevRes) => {
                console.log('[DEBUG] Previous month template:', prevRes);
                
                const data = {
                    templateId: this.state.templateId,
                    newTemplateS3Path: newTemplateS3Path,
                    copyFromTemplateId: prevRes.previousTemplateId || null
                };
                
                this.compareAndApplyConditions(data, prevRes.previousTemplateName);
            },
            onFailure: () => {
                // If can't get previous month, just compare with current
                const data = {
                    templateId: this.state.templateId,
                    newTemplateS3Path: newTemplateS3Path
                };
                
                this.compareAndApplyConditions(data, null);
            }
        });
    }
    
    compareAndApplyConditions = (data, previousMonthName) => {
        this.props.compareTemplateColumns(data, {
            onSuccess: (res) => {
                console.log('[DEBUG] compareTemplateColumns response:', res);
                
                if (!res.hasExistingConditions) {
                    // No existing conditions - clear as before
                    this.setState({ templateCol: [] });
                    console.log('No existing conditions to preserve.');
                    return;
                }
                
                const sourceMessage = res.copiedFromPreviousMonth && previousMonthName 
                    ? `\n\n(Copied from ${previousMonthName})`
                    : '';
                
                if (res.columnsMatch) {
                    // ✅ Perfect match - preserve all conditions
                    this.setState({ templateCol: res.preservableConditions });
                    alert(`Template uploaded successfully!\n\n✅ All ${res.preservableConditions.length} column conditions preserved (columns match perfectly).${sourceMessage}`);
                    console.log('All conditions preserved - columns match.');
                } 
                else if (res.preservableCount > 0) {
                    // ⚠️ Partial match - show user what's preserved
                    this.setState({ 
                        templateCol: res.preservableConditions,
                        templateComparisonModalOpen: true,
                        comparisonResult: res
                    });
                    console.log(`Partial match: ${res.preservableCount}/${res.existingConditionsCount} conditions preserved.`);
                } 
                else {
                    // ❌ No matching columns - clear all
                    this.setState({ templateCol: [] });
                    alert(`Template uploaded successfully!\n\n⚠️ Warning: New template has completely different columns.\nAll ${res.existingConditionsCount} previous conditions were cleared.${sourceMessage}`);
                    console.log('No matching columns - all conditions cleared.');
                }
            },
            onFailure: (error) => {
                // Fallback: clear conditions on error
                console.error('[DEBUG] compareTemplateColumns failed:', error);
                this.setState({ templateCol: [] });
                console.error('Template comparison failed:', error);
            }
        });
    }


    uploadFile = async (fileName, type) => {
        // console.log(type, 'type')
        this.setState({ fileName: fileName, fileType: type, modalOpen: true })

    }

    hotpsotSplitLoadData = () => {
        this.setState({ loaderStatus: true })
        let data = {
            templateId: this.state.templateId,
            disType: this.state.disType
        }
        this.props.getHotspotSplitStatus(this.state.templateId, {
            onSuccess: (res) => {
                if (res.master.splitStatus == 'Completed') {
                    clearTimeout(apiTimeout)
                    this.props.getsplittedFiles(
                        this.state.templateId,
                        {
                            onSuccess: (res) => {
                                this.setState({ auditingSplit: res.auditingFiles, nonAuditingSplit: res.nonAuditingFiles, loaderStatus: false, splitProcess: false })
                            },
                            onFailure: () => {
                            }
                        })
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.hotpsotSplitLoadData, 3000)
    }

    splitFiles = async () => {
        if (this.state.auditingSplit.length > 0 && this.state.nonAuditingSplit.length > 0) {
            alert('Split Process Already Done')
        }
        else {
            let templateId = this.state.templateId;
            this.setState({ loaderStatus: true })
            await this.props.splitSitewiseProcess(templateId, {
                onSuccess: () => {
                    apiTimeout = setTimeout(this.hotpsotSplitLoadData, 3000)
                }
            })
        }

    }


    siteData = (rowData, checkedValue) => {

        this.setState({ 'selectedDist': rowData })

    };

    sendedData = (rowData, row) => {
        this.setState({ 'selectedDist': rowData })
    };

    hotspotCreditNoteProcess = () => {
        // this.setState({ loaderStatus: true })
     
        this.props.getCreditNoteProcessStatus(this.state.templateId, {
            onSuccess: (res) => {
                if (res.status.creditNoteProcess == 'Completed') {
                    clearTimeout(apiTimeout)
                    this.props.getsplittedFiles(
                        this.state.templateId,
                        {
                            onSuccess: (res) => {
                                
                                this.setState({ auditingSplit: res.auditingFiles, nonAuditingSplit: res.nonAuditingFiles, loaderStatus: false, splitProcess: false })
                                alert('Credit Note Processed Successfully')
                            },
                            onFailure: () => {
                            }
                        })
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.hotspotCreditNoteProcess, 3000)
    }

    hotspotReleaseWorking = () => {
        this.props.getCreditNoteProcessStatus(this.state.templateId, {
            onSuccess: (res) => {
                if(res.status.workingRelease){
                    if (res.status.workingRelease == 'Completed') {
                        clearTimeout(apiTimeout)
                        this.props.getsplittedFiles(
                            this.state.templateId,
                            {
                                onSuccess: (res) => {
                                    
                                    this.setState({ auditingSplit: res.auditingFiles, nonAuditingSplit: res.nonAuditingFiles, loaderStatus: false, splitProcess: false,alertModalOpen:false,releaseAlertMoalOpen:false })
                                    alert('Working File Released Successfully')
                                },
                                onFailure: () => {
                                }
                            })
                    }
                }
                
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.hotspotReleaseWorking, 3000)
    }

    releaseWorking = () => {
        this.setState({loaderStatus:true})
        if (Object.keys(this.state.selectedDist).length !== 0) {
            this.props.sendWorkingFiles(this.state.selectedDist, {
                onSuccess: () => {
                    apiTimeout = setTimeout(this.hotspotReleaseWorking, 3000)
                    // this.setState({loaderStatus:false})
                    // alert('Working Files Released Successfully')
                },
                onFailure: () => {

                }
            })
        }
        else {
            alert('Please Select Distributor')
        }

    }

    processCreditNotes = () => {
        if (Object.keys(this.state.selectedDist).length !== 0) {
            if (this.state.selectedDist.dseClientUpdate != 'pending') {
                this.setState({ loaderStatus: true })
                this.props.processCreditNote(this.state.selectedDist, {
                    onSuccess: () => {
                        apiTimeout = setTimeout(this.hotspotCreditNoteProcess, 3000)
                    },
                    onFailure: () => {
                    }
                })
            }
            else {
                alert("DSE File Process Not Yet Done")
            }
        }
        else {
            alert('Please Select Distributor')
        }
    }

    hotspotReleaseCreditNote = () =>{
        this.props.getCreditNoteProcessStatus(this.state.templateId, {
            onSuccess: (res) => {
                if(res.status.creditNoteRelease){
                    if (res.status.creditNoteRelease == 'Completed') {
                        clearTimeout(apiTimeout)
                        this.props.getsplittedFiles(
                            this.state.templateId,
                            {
                                onSuccess: (res) => {
                                    
                                    this.setState({ auditingSplit: res.auditingFiles, nonAuditingSplit: res.nonAuditingFiles, loaderStatus: false, splitProcess: false,alertModalOpen:false,releaseAlertMoalOpen:false })
                                    alert('CreditNote Files Released Successfully')
                                },
                                onFailure: () => {
                                }
                            })
                    }
                }
                
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.hotspotReleaseCreditNote, 3000)
    }

    releaseCreditNote = () => {
        this.setState({loaderStatus:true})
        if (Object.keys(this.state.selectedDist).length !== 0) {
            if (this.state.selectedDist.creditNoteStatus != 'pending') {
                this.props.sendCreditNoteFiles(this.state.selectedDist, {
                    onSuccess: () => {
                        apiTimeout = setTimeout(this.hotspotReleaseCreditNote, 3000)
                        // this.setState({loaderStatus:false})
                        // alert('Credit Note Files Released Successfully')
                    },
                    onFailure: () => {

                    }
                })
            }
            else {

            }

        }
        else {
            alert('Please Select Distributor')
        }
    }

    checkInput = () => {
        this.props.checkHotspotInputsData(this.state.templateId, {
            onSuccess: (res) => {
                    console.log('hotspot - res : ', res)
                if (res.missing_files.length) {
                    this.setState({ missingFiles: res.missing_files, proceed: true, validationModalOpen: true })
                }
                else {
                    this.setState({ proceed: false })
                    alert("All Inputs File Uploaded Successfully")
                }
            },
            onFailure: () => {

            }
        })
    }

    applyHotspotConditions = () => {

        const {selectedYear, selectedTemplate} = this.state;
        if (!selectedYear || !selectedTemplate) {
            if (!selectedYear && !selectedTemplate) {
                alert("Please select the Year and Template Month.")
            } else if (!selectedYear) {
                alert("Please select the Year.")
            } else {
                alert("Please select the Template Month.")
            }
            return;
        }
        
        if (this.state.templateCol.length == 0) {
            this.props.extractHotspotTemplateCol(this.state.templateId, {
                onSuccess: (res) => {
                    if (res.result.length) {
                        this.setState({ templateCol: res.result, templateColModal: true })
                    }
                    else {
                        // this.setState({templateCol:[]})
                        alert('Please Upload Template Format')
                    }
                }
            })
        }
        else {
            this.setState({ templateColModal: true })
        }

    }

    dropDownColOnChange = (e, data) => {
        let templateCol = this.state.templateCol
        if (templateCol.length) {
            templateCol.map((col) => {
                if (col.colName == data.additionLabel) {
                    col.fileType = data.value
                }
            })
        }
        this.setState({ templateCol: templateCol })
    }

    fileColOnChange = (e, data) => {
        let templateCol = this.state.templateCol
        if (templateCol.length) {
            templateCol.map((col) => {
                if (col.colName == data.colName) {
                    col.colNum = e.target.value
                }
            })
        }
        this.setState({ templateCol: templateCol })

    }

    saveFileColTemplate = () => {
        // console.log(this.state.templateCol, 'templateCol')
        let data = {
            colConditions: this.state.templateCol,
            templateId: this.state.templateId
        }
        this.props.saveHotspotTemplateCol(data, {
            onSuccess: () => {

            },
            onFailure: () => {

            }
        })
    }


    downloadApprovalEmails = ()=>{
        let data = {
            templateId:this.state.templateId,
            fileName:'hotspot-approvalEmails'
        }
        this.props.getApprovedEmails(data,{
            onSuccess:(res)=>{
                if(res.approvalData.length>0){
                    this.setState({approvedEmailData:res.approvalData[0].result,approvalModalOpen:true})
                }
                else{
                    alert('No Data Found')
                }
            },
            onFailure:()=>{

            }
        })
        // this.setState({approvalModalOpen:true})
    }

    showConfirmationAlert =() =>{
        this.setState({alertModalOpen:true})
    }

    showReleaseConfirmationAlert = () =>{
        this.setState({releaseAlertMoalOpen:true})
    }

     downloadDseDetails = () =>{
                        this.setState({loaderStatus:true})
                        this.props.downloadallDSEfiles(this.state.templateId,'hotspotDSE',{
                            onSuccess:()=>{
                                this.setState({loaderStatus:false})
                            },
                            onFailure:()=>{
                                this.setState({loaderStatus:false})
                            }
                        })
                    }
            
                    downloadCreditNoteDetails = () =>{
                        this.setState({loaderStatus:true})
                        this.props.downloadallCreditNotefiles(this.state.templateId,'hotspotCreditNote',{
                            onSuccess:()=>{
                                this.setState({loaderStatus:false})
                            },
                            onFailure:()=>{
                                this.setState({loaderStatus:false})
                            }
                        })
                    }

                    sendEmailforApproval = () =>{
                                        this.setState({loaderStatus:true})
                                        let data = {
                                            templateId:this.state.templateId,
                                            disType:"hotspot"
                                        }
                                        this.props.sendApprovalEmailToPandG(data,{
                                            onSuccess:(res)=>{
                                                alert(res.status)
                                                this.setState({loaderStatus:false})
                                            },
                                            onFailure:(res)=>{
                                                alert(res.status)
                                                this.setState({loaderStatus:false})
                                            }
                                        })
                            }
        


    render() {

        console.log(this.state.selectedDist,'selectedDist')

        var yearsList = [
            {
                'key': '2023',
                'value': '2023',
                'text': '2023'
            },
            {
                'key': '2024',
                'value': '2024',
                'text': '2024'
            },
            {
                'key': '2025',
                'value': '2025',
                'text': '2025'
            },
             {
                'key': '2026',
                'value': '2026',
                'text': '2026'
            }
        ]

        const auditing_split_columns = [
            {
                Header: "Site Name",
                accessor: "siteName",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.siteName}</span>;
                },
            },
            {
                Header: "Location",
                accessor: "location",
                width:200,
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.location}</span>;
                },
            },
            {
                Header: "Large A&B Working",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile( original.large)}
                    />;
                },
            },
            {
                Header: "Medium Working",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile( original.medium)}
                    />;
                },
            },
          
          
            {
                Header: "Large A&B Credit Note",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile( original.creditNoteLarge)}
                        disabled={original.creditNoteStatus == 'pending' ? true : false}
                    />;
                },
            },
            {
                Header: "Medium Credit Note",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile( original.creditNoteMedium)}
                        disabled={original.creditNoteStatus == 'pending' ? true : false}
                    />;
                },
            },
            {
                Header: "Files Release Status",
                accessor: "workingReleaseCheck",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    if (original.workingReleaseCheck == 'Completed') {
                        return <h4>Completed</h4>;
                    }

                    else {
                        return <h4>Pending</h4>;
                    }
                },
            },
            {
                Header: "Files Release Date",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                  
                        return <h4>{original.releasingDate}</h4>;
                   
                },
            },
            {
                Header: "Large Working Amount",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.largeWorkingCount && original.largeWorkingCount != undefined ? original.largeWorkingCount : '-'}</h4>;
                },
            },
            {
                Header: "Large Credit Amount",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.largeCreditCount && original.largeCreditCount != undefined ? original.largeCreditCount : "-" }</h4>;
                },
            },
            {
                Header: "Medium Working Amount",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.mediumWorkingCount && original.mediumWorkingCount != undefined ? original.mediumWorkingCount : "-" }</h4>;
                },
            },
            {
                Header: "Medium Credit Amount",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.mediumCreditCount && original.mediumCreditCount != undefined ? original.mediumCreditCount: "-" }</h4>;
                },
            },
        ];

        const non_auditing_split_columns = [
            {
                Header: "Site Name",
                accessor: "siteName",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.siteName}</span>;
                },
            },
            {
                Header: "Location",
                accessor: "location",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.location}</span>;
                },
            },
            {
                Header: "Large A&B Working",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile(original.large)}
                    />;
                },
            },
            {
                Header: "Medium Working",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile(original.medium)}
                    />;
                },
            },
        
            {
                Header: "Large A&B Credit Note",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        disabled={original.creditNoteStatus == 'pending' ? true : false}
                    />;
                },
            },
            {
                Header: "Medium Credit Note",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        disabled={original.creditNoteStatus == 'pending' ? true : false}
                    />;
                },
            },
        ]

        var fileType = [
            {
                'key': 'Channel1 Target',
                'value': 'Channel1 Target',
                'text': 'Channel1 Target'
            },
            {
                'key': 'DGP Achievement',
                'value': 'DGP Achievement',
                'text': 'DGP Achievement'
            },
            {
                'key': 'PSR',
                'value': 'PSR',
                'text': 'PSR'
            },
            {
                'key': 'Photo Audit',
                'value': 'Photo Audit',
                'text': 'Photo Audit'
            },
            {
                'key': 'Physical Audit',
                'value': 'Physical Audit',
                'text': 'Physical Audit'
            },
            {
                'key': 'DGP Top Channel Corporate Program Targets',
                'value': 'DGP Top Channel Corporate Program Targets',
                'text': 'DGP Top Channel Corporate Program Targets'
            },
            {
                'key': 'Formula',
                'value': 'Formula',
                'text': 'Formula'
            },
            {
                'key': 'Plan Data',
                'value': 'Plan Data',
                'text': 'Plan Data'
            }
        ]

        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Dimmer active={this.state.loaderStatus}>
                        <Loader size="massive">File Processing.....</Loader>
                    </Dimmer>
                </div>

                {/* <br /> */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ marginLeft: 10 }}>
                        <Dropdown placeholder='Select Year' search selection options={yearsList}
                            onChange={this.dropDownYearOnChange}
                            value={this.state.selectedYear}
                        />
                    </div>
                    <div style={{ marginLeft: 10 }}>
                        <Dropdown placeholder='Select Template Month' search selection options={this.state.templateMonths}
                            onChange={this.dropDownTemplateOnChange}
                            value={this.state.selectedTemplate}
                        />
                    </div>
                    <div style={{ marginLeft: 10 }}>
                        <Dropdown placeholder='Select Distributor' search selection multiple options={this.state.distributors}
                            onChange={this.dropDownDistributorOnChange}
                            value={this.state.selectedDistributor}
                        />
                    </div>
        
                    <div style={{ marginLeft: 10}}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label="(Mid-month)Sales Start Date"
                                value={this.state.startDate || null}
                                onChange={(newValue) => {
                                    this.setState({ startDate: newValue });
                                }}
                                renderInput={(params) => <TextField
                                    {...params}
                                    size="small"
                                    InputLabelProps={{
                                    ...params.InputLabelProps,
                                    sx: {
                                        fontSize: '0.90rem',
                                    },
                                    }}
                                />}
                                inputFormat="dd-MM-yyyy"
                            />
                        </LocalizationProvider>
                    </div>
                    <div style={{ marginLeft: 10}}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DatePicker
                                label="(Mid-month)Sales End Date"
                                value={this.state.endDate || null}
                                onChange={(newValue) => {
                                    this.setState({ endDate: newValue });
                                }}
                                minDate={this.state.startDate}
                                renderInput={(params) => <TextField
                                    {...params}
                                    size="small"
                                    InputLabelProps={{
                                    ...params.InputLabelProps,
                                    sx: {
                                        fontSize: '0.90rem',
                                    },
                                    }}
                                />}
                                inputFormat="dd-MM-yyyy"
                            />
                        </LocalizationProvider>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.checkInput()}
                        >

                            Input Validation
                            <Icon name="check" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    {/* <div style={{ display: 'flex', flexDirection: 'row',marginTop:20 }}> */}
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.uploadFile('hotspotPlanData', 'hotspotPlanData')}
                        >

                            Plan Data
                            <Icon name="upload" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.state.planDataUrl != '' ? this.downloadfile(this.state.planDataUrl) : alert('Data Not Found for Selected Month')}
                        >

                            Plan Data
                            <Icon name="download" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>

                    

                    {/* </div> */}


                </div>
                <div style={{ display: 'flex', flexDirection: 'row',marginTop:20 }}>
                     <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.uploadFile('hotspotPgTargetData', 'hotspotPgTargetData')}
                        >

                            P&G Target Data
                            <Icon name="upload" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.state.pgTargetDataUrl != '' ? this.downloadfile(this.state.pgTargetDataUrl) : alert('Data Not Found for Selected Month')}
                        >

                            P&G Target Data
                            <Icon name="download" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            // onlick={() => this.uploadFile('hotspotTemplate', 'hotspotTemplate')}
                            onClick={this.templateUploadCheck}

                        >

                            Upload Template
                            <Icon name="upload" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={this.templateDownloadCheck}
                        >

                            Download Template
                            <Icon name="download" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.applyHotspotConditions()}
                        >
                            Apply Conditions
                            <Icon name="check" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                  
     
                         <div>
                         <Label
                             style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                             size="large"
                             color="blue"
                             onClick={() => this.uploadFile('hotspot-approvalEmails', 'hotspot-approvalEmails')}
                         >
 
                             Upload P&G Approval Emails
                             <Icon name="upload" style={{ marginLeft: 10 }} />
                         </Label>
                     </div>
                     <div>
                         <Label
                             style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                             size="large"
                             color="blue"
                             onClick={() => this.downloadApprovalEmails()}
                         >
 
                             Download P&G Approval Emails
                             <Icon name="download" style={{ marginLeft: 10 }} />
                         </Label>
                     </div>
                    
                   
                </div>
                <div style={{ display: 'flex', flexDirection: 'row',marginTop:20 }}>
                     <div>
                                                            <Label
                                                                style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                                                                size="large"
                                                                color="blue"
                                                                onClick={() => this.uploadFile('hotspot-approvedFiles', 'hotspot-approvedFiles')}
                                                            >
                                    
                                                                Upload Files for P&G Approval
                                                                <Icon name="upload" style={{ marginLeft: 10 }} />
                                                            </Label>
                                                        </div>
                                    
                                                         <div>
                                                            <Label
                                                                style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                                                                size="large"
                                                                color="blue"
                                                                onClick={() => this.sendEmailforApproval()}
                                                            >
                                    
                                                                Send Email for P&G Approval
                                                                <Icon name="envelope" style={{ marginLeft: 10 }} />
                                                            </Label>
                                                        </div>
                </div>

                <Grid columns={3} style={{ marginTop: 20 }}>
                    <GridColumn style={{ marginTop: 25 }}>
                        <Card.Group>
                            <h2 style={{ marginLeft: 10 }}>Final Disbursement Processing</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image floated='right' size='mini' src={processIcon} style={{ cursor: 'pointer' }} />
                                    <Card.Description>
                                        <h4>
                                            Automation Status: 
                                            <strong style={{ color: this.state.automationStatus === 'Completed' ? 'green' : this.state.automationStatus === 'Processing' ? 'orange' : 'red' }}>
                                                {`   ${this.state.automationStatus}`}
                                            </strong>
                                        </h4>
                                    </Card.Description>
                                </Card.Content>
                                <Card.Content extra>
                                    <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                                        {this.state.initial ? (
                                            <Button basic color='green' onClick={() => this.start()} disabled={this.state.proceed}>
                                                <Icon name="hand point up" />Start
                                            </Button>
                                        ) : (
                                            <>
                                                <Button basic color='orange' onClick={() => this.start()}>
                                                    <Icon name="redo" />Re-Start
                                                </Button>
                                                <Button basic color='green' onClick={() => this.downloadfile( this.state.outputUrl)} disabled={!this.state.downloadEnable}>
                                                    <Icon name="download" />Download
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </GridColumn>

                    <GridColumn style={{ marginTop: 25 }}>
                        <Card.Group>
                            <h2 style={{ marginLeft: 10 }}>Automation Result</h2>
                            <Card className="fluid" style={{ width: 375, height: 200 }}>
                                <Card.Content>
                                    <Image floated='right' size='mini' src={excel} style={{ cursor: 'pointer' }} />
                                    <Card.Header><h3>Auditing Sites</h3></Card.Header>
                                    <Card.Description>
                                        <h3>
                                            Large & Medium
                                            <Icon name="arrow circle down" style={{ marginLeft: 25,cursor:'pointer' }} color='green' disabled={!this.state.downloadEnable} onClick={() => this.downloadfile(this.state.hotspotAuditingUrl)} />
                                            
                                        </h3>
                                    </Card.Description>

                                    <Card.Header style={{ marginTop: 25 }}><h3>Non Auditing Sites</h3></Card.Header>
                                    <Card.Description>
                                        <h3>
                                            Large & Medium
                                            <Icon name="arrow circle down" style={{ marginLeft: 25,cursor:'pointer' }} color='green' disabled={!this.state.downloadEnable} onClick={() => this.downloadfile(this.state.hotspotNonAuditUrl)} />
                                            
                                        </h3>
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </GridColumn>

                    <GridColumn style={{ marginTop: 25 }}>
                        <Card.Group>
                            <h2 style={{ marginLeft: 20 }}>Approved Disbursement</h2>
                            <Card className="fluid" style={{ width: 350, height: 200, marginLeft: 20 }}>
                                <Card.Content>
                                    <Image floated='right' size='mini' src={excel} style={{ cursor: 'pointer' }} />
                                    <Card.Header><h3>Auditing Sites</h3></Card.Header>
                                    <Card.Description>
                                        <h3>
                                            Large & Medium
                                            <Icon name="upload" style={{ marginLeft: 25,cursor:'pointer' }} color='orange' onClick={() => this.uploadFile('Auditing', 'Auditing')} />
                                            <Icon disabled={this.state.approvedHotspotAuditingUrl !='' && this.state.approvedHotspotAuditingUrl != undefined ? false : true} name="arrow circle down" style={{ marginLeft: 25,cursor:'pointer' }} color='green' onClick={() => this.downloadfile(this.state.approvedHotspotAuditingUrl)} />
                                        </h3>
                                    </Card.Description>

                                    <Card.Header style={{ marginTop: 25 }}><h3>Non Auditing Sites</h3></Card.Header>
                                    <Card.Description>
                                        <h3>
                                            Large & Medium
                                            <Icon name="upload" style={{ marginLeft: 25,cursor:'pointer' }} color='orange' onClick={() => this.uploadFile('NonAuditing', 'NonAuditing')} />
                                            <Icon disabled={this.state.approvedHotspotNonAuditingUrl !='' && this.state.approvedHotspotNonAuditingUrl != undefined ? false : true} name="arrow circle down" style={{ marginLeft: 25,cursor:'pointer' }} color='green' onClick={() => this.downloadfile(this.state.approvedHotspotNonAuditingUrl)} />
                                        </h3>
                                    </Card.Description>
                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </GridColumn>
                </Grid>

                <br></br>
                <br></br>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <p style={{ fontSize: 25 }}>
                            <h1
                                style={{

                                    flex: "0 0 30px",
                                    display: "inline-block",
                                    color: "#2185d0",
                                }}
                            >
                                Disbursement Working for Sites
                            </h1>
                        </p>
                    </div>

                    <div >
                        <button
                            style={{
                                justifyContent: 'flex-end',
                                marginLeft: 15,
                                marginTop: 5,
                                cursor: 'pointer',
                                backgroundColor: '#2185D0',
                                color: 'white',
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '5px'
                            }}
                            onClick={() => this.splitFiles()}
                            disabled={this.state.approvedHotspotAuditingUrl != '' && this.state.approvedHotspotAuditingUrl != undefined ? false : true}
                        >

                            Split Files
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </button>
                    </div>
                    <div>
                        <button
                            style={{
                                justifyContent: 'flex-end',
                                marginLeft: 15,
                                marginTop: 5,
                                cursor: 'pointer',
                                backgroundColor: '#2185D0',
                                color: 'white',
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '5px'
                            }}
                            onClick={() => this.showReleaseConfirmationAlert()}
                            // disabled={this.state.splitProcess}
                        >

                            Release Workings & CreditNotes
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </button>
                    </div>
                    {/* <div>
                        <button
                            style={{
                                justifyContent: 'flex-end',
                                marginLeft: 15,
                                marginTop: 5,
                                cursor: 'pointer',
                                backgroundColor: '#2185D0',
                                color: 'white',
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '5px'
                            }}
                            onClick={() => this.processCreditNotes()}
                        >

                            Process CreditNote
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </button>
                    </div>
                    <div>
                        <button
                            style={{
                                justifyContent: 'flex-end',
                                marginLeft: 15,
                                marginTop: 5,
                                cursor: 'pointer',
                                backgroundColor: '#2185D0',
                                color: 'white',
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '5px'
                            }}
                            onClick={() => this.showConfirmationAlert()}
                        >

                            Release CreditNote
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </button>
                    </div> */}
                     {/* <div>
                                                                <Label
                                                                    style={{ justifyContent: 'flex-end',marginLeft: 10,marginTop: 5, cursor: 'pointer' }}
                                                                    size="large"
                                                                    color="blue"
                                                                    onClick={() => this.downloadDseDetails()}
                                                                    disabled={true}
                                                                >
                                        
                                                                     DSE
                                                                    <Icon name="download" style={{ marginLeft: 10 }} />
                                                                </Label>
                                                            </div> */}
                                                            <div>
                                                                <Label
                                                                    style={{ justifyContent: 'flex-end',marginLeft: 10,marginTop: 5, cursor: 'pointer' }}
                                                                    size="large"
                                                                    color="blue"
                                                                    onClick={() => this.downloadCreditNoteDetails()}
                                                                    disabled={true}
                                                                >
                                        
                                                                     Credit Note
                                                                    <Icon name="download" style={{ marginLeft: 10 }} />
                                                                </Label>
                                                            </div>

                </div>


                <p style={{ fontSize: 18 }}>
                    <h1
                        style={{
                            flex: "0 0 30px",
                            display: "inline-block",
                            color: "#0000000",
                        }}
                    >
                        Auditing Sites
                    </h1>
                </p>
                <CheckboxTable
                    data={this.state.auditingSplit}
                    columns={auditing_split_columns}
                    sendedData={this.siteData}
                />
                <br></br>
                <br></br>
                <p style={{ fontSize: 18 }}>
                    <h1
                        style={{

                            flex: "0 0 30px",
                            display: "inline-block",
                            color: "#0000000",
                        }}
                    >
                        Non Auditing Sites
                    </h1>
                </p>
                <CheckboxTable
                    data={this.state.nonAuditingSplit}
                    columns={non_auditing_split_columns}
                    sendedData={this.siteData}
                />

                <Modal
                    open={this.state.formulaModalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <strong>{`IF No formula for a column please specifiy the column as like "A -- No Formula"`}</strong>
                            {this.state.formulas.length > 0 && this.state.formulas.map((d) => {
                                return (
                                    <Grid columns={1}>
                                        <Grid.Row>
                                            <GridColumn style={{ marginTop: 20 }}>
                                                <Form.Input
                                                    type="any"
                                                    label={Object.keys(d)[0]}
                                                    value={Object.values(d)[0]}
                                                    onChange={(e) => this.formulaOnChange(e, d)}
                                                    placeholder={Object.values(d)[0]}
                                                />
                                            </GridColumn>
                                        </Grid.Row>
                                    </Grid>
                                )

                            })}



                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.saveFormulas}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>

                <Modal
                    open={this.state.modalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <Input
                                            type="file"
                                            accept=".xlsx"
                                            onChange={this.fileupload}
                                            multiple
                                        />
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadRawFile}
                                title={'Upload'}
                                color={'green'}
                                iconColor={'white'}
                                disabled={this.state.fileUploaded == true ? false : true}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>
                <Modal
                    open={this.state.validationModalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>

                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h1>Below Files Need to Process. Please Process in Raw File Processing</h1>
                                        {this.state.missingFiles.map((file, index) => (
                                            <h3 key={index}>{index + 1} : {file}</h3>
                                        ))}
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>

                </Modal>


                <Modal
                    open={this.state.templateColModal}
                    onClose={this.closeFormulaModal}
                    size="large"
                >
                    <Modal.Content>
                        <Grid columns={3}>
                            <Grid.Row>
                                <Grid.Column>
                                    <h4>Header</h4> {/* Your header content */}
                                </Grid.Column>
                                <Grid.Column>
                                    <h4>File Type</h4>
                                </Grid.Column>
                                <Grid.Column>
                                    <h4>Column Number</h4> {/* Only for the header */}
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>


                        {/* {console.log(this.state.templateCol, 'templateColll')} */}
                        {this.state.templateCol.map((d) => {

                            return (
                                <Grid columns={3}>
                                    <Grid.Row>

                                        <Grid.Column style={{ marginTop: 20 }}>
                                            {d.colName}

                                        </Grid.Column>
                                        <GridColumn style={{ marginTop: 20 }}>
                                            <Dropdown placeholder='File Type' search selection options={fileType}
                                                onChange={this.dropDownColOnChange}
                                                additionLabel={d.colName}
                                                value={d.fileType}

                                            />
                                        </GridColumn>
                                        <GridColumn style={{ marginTop: 20 }}>
                                            <TextArea
                                                style={{ width: '100%', height: '140%' }}
                                                type="any"
                                                // label="Column Number"
                                                value={d.colNum}
                                                onChange={(e) => this.fileColOnChange(e, d)}
                                                placeholder=""
                                            />
                                        </GridColumn>

                                    </Grid.Row>
                                </Grid>
                            )

                        })}
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.saveFileColTemplate}
                                title={'Save'}
                                color={'green'}
                                iconColor={'white'}
                            // disabled={this.state.checkField == true ? false : true}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>

                <Modal
                    open={this.state.approvalModalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                           {this.state.approvedEmailData.length > 0 && this.state.approvedEmailData.map((d)=>{
                            return(
                                <>
                                <h3>{d.fileName} :  <Icon name="arrow circle down" style={{ marginLeft: 25,cursor:'pointer' }} color='green' onClick={() => this.downloadfile(d.fileUrl)} /></h3>
                                </>
                            )
                           })}



                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.alertModalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                        <h1><b>Below Sites You're Choosing for Credit Note Release Process </b></h1>
                           {this.state.selectedDist.length > 0 && this.state.selectedDist.map((d,index)=>{
                            return(
                                <>
                                <h3>{index + 1}{'. '}{d.siteName}-{d.location}</h3>
                                </>
                            )
                           })}
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                        <ButtonHandler
                                click={this.releaseCreditNote}
                                isIcon={true}
                                color={'green'}
                                iconName={'mail'}
                                iconColor={'white'}
                                title={'Send'}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>
                <Modal
                    open={this.state.releaseAlertMoalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                        <h1><b>Below Sites You're Choosing for Working Files Release Process </b></h1>
                           {this.state.selectedDist.length > 0 && this.state.selectedDist.map((d,index)=>{
                            return(
                                <>
                                <h3>{index + 1}{'. '}{d.siteName}-{d.location}</h3>
                                </>
                            )
                           })}
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                        <ButtonHandler
                                click={this.releaseWorking}
                                isIcon={true}
                                color={'green'}
                                iconName={'mail'}
                                iconColor={'white'}
                                title={'Send'}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>   
                
                {this.renderTemplateComparisonModal()}

            </div>

        )


    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchAutomationStatusData,
            runAutomationScript,
            fetchUseraction,
            getDisbursementFormulas,
            updateDisbursementFormulas,
            fetchTemplates,
            getWorkingFiles,
            rawFileProcess,
            getsplittedFiles,
            getSplitFilesFormulas,
            updateSplitFileFormulas,
            processApprovedFiles,
            splitSitewiseProcess,
            sendWorkingFiles,
            processCreditNote,
            sendCreditNoteFiles,
            getHotspotSplitStatus,
            getPlanData,
            checkHotspotInputsData,
            extractHotspotTemplateCol,
            saveHotspotTemplateCol,
            getHotspotTemplateConditions,
            getApprovedEmails,
            getCreditNoteProcessStatus,
            downloadallDSEfiles,
            downloadallCreditNotefiles,
            sendApprovalEmailToPandG,
            compareTemplateColumns,
            getPreviousMonthTemplate
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HotspotAutomation));
